import {defineStore} from 'pinia';
import {ACCESS_TOKEN} from './mutation-types';
import {login, logout, getInfo} from "@/api/user";
import {constantRoutes, asyncRoutes} from "@/config/router-config";
import storage from 'store';
import cloneDeep from 'lodash.clonedeep';


function hasPermission (permission, route) {
    if (route.meta && route.meta.permission) {
        // console.log('hasPermission', permission)
        if (permission === undefined) {
            return false
        }
        let flag = false
        for (let i = 0, len = permission.length; i < len; i++) {
            flag = route.meta.permission.includes(permission[i])
            if (flag) {
                return true
            }
        }
        return false
    }
    return true
}

function filterAsyncRouter (routerMap, role) {
    const accessedRouters = routerMap.filter(route => {
        if (hasPermission(role.permissionList, route)) {
            if (route.children && route.children.length) {
                route.children = filterAsyncRouter(route.children, role)
            }
            return true
        }
        return false
    })
    return accessedRouters
}

export const mainStore = defineStore('main', {
    state: () => {
        return {
            token: '',
            roles: [],
            isMobile: false,
            username: "",
            avatar: "",
            doctorId: 0,
            count: 0,
            routers: constantRoutes,
            addRouters: [],
            memberPage: 1
        }
    },
    getters: {},
    actions: {
        userLogin(params) {
            console.log(params, 'userlogin');
            return new Promise((resolve, reject) => {
                login(params).then(res => {
                    console.log("<-> login response : %o", res);
                    if (res.code === 0) {
                        const data = res.data;
                        storage.set(ACCESS_TOKEN, data.token, 7 * 24 * 60 * 60 * 1000);
                        this.token = data.token;
                        resolve(data.name);
                    } else {
                        reject(res);
                    }
                }).catch(res => {
                    res.code = res.response.status;
                    reject(res)
                });
            });
        },
        userGetInfo() {
            return new Promise((resolve, reject) => {
                getInfo().then(res => {
                    console.log("<-> get user info : %o", res);
                    const data = res.data;
                    if (data.userProfile && data.userProfile.permissions.length > 0) {
                        const role = data.userProfile;
                        role.permissions = data.userProfile.permissions;
                        role.permissionList = role.permissions.map((permission) => {
                            return permission.permissionId;
                        });
                        this.roles = data.userProfile;
                        this.avatar = data.avatar;
                        this.doctorId = data.doctorId;
                        this.username = data.name;
                        resolve(res);
                    } else {
                        reject(new Error("getInfo: roles must be a non-null array !"));
                    }
                }).catch(err => {
                    reject(err);
                });
            });
        },
        userLogout() {
            return new Promise((resolve) => {
                logout().then(() => {
                    this.token = '';
                    this.roles = [];
                    storage.remove(ACCESS_TOKEN)
                    resolve()
                }).catch((err) => {
                    console.log('logout fail:', err)
                    resolve()
                }).finally(() => {
                });
            });
        },
        generateRoutes(data) {
            return new Promise(resolve => {
                const { roles } = data;
                const routerMap = cloneDeep(asyncRoutes)
                const accessedRouters = filterAsyncRouter(routerMap, roles)
                this.addRouters = accessedRouters;
                this.routers = constantRoutes.concat(accessedRouters);
                resolve()
            })
        }
    },
});